<template>
  <div>
  <input type="text" v-model="Metin"  cols="30" rows="10" class="form-control p-4 mb-4" />
  <button v-on:click="KelimeleriHesapla" class="btn btn-primary"> Hesapla </button> 
  <hr>
    <div>
    <table id="datatable" class="table">
        <thead>
            <tr>
            <th>Kelime</th>
            <th>Geçtiği Sayı</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item, name) in Sonuclar" :key="name">
             <td> {{ name }}</td>
             <td> {{ item }} </td>
            </tr>
        </tbody>
    </table>
  </div>
  </div>
</template>

<script>
 import "jquery/dist/jquery.min.js";
 import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";

export default {
    data(){
        return{
            Metin:"",
            Sonuclar:{},
        }
    },
    methods:{
        KelimeleriHesapla(){                                    

                    let metin = this.Metin.toLowerCase();
                    let words = metin.replace(/[,.'"?!]+/gi,"").split(/[ ,]+/);
                    let wordMap = {};

                    for (let i = 0; i < words.length; i++) {
                        let currentWordCount = wordMap[words[i]];
                        let count = currentWordCount ? currentWordCount : 0;
                        wordMap[words[i]] = count + 1;
                    }
                   
                   this.Sonuclar = wordMap;
                   localStorage.Sonuclar = JSON.stringify(wordMap);
        },
    },
    mounted(){
          $("#datatable").DataTable({
                "paging":   false,
                "order": [[ 1, "desc" ]]
          });
    }
    ,
    created(){
        this.Sonuclar = JSON.parse(localStorage.Sonuclar);
      
    }
}
</script>

<style>

</style>